import log from "loglevel";

import { BrandTheme } from "./brands";
import { LauncherPosition } from "./store/definitions";

/*
 * Config de marca vinda do dashboard em runtime (cor + logo + posição + borda do launcher), por marca.
 * Permite trocar tema/logo/posição pelo painel sem rebuild. Best-effort: se a env não estiver
 * setada ou o fetch falhar, retorna {} e o widget usa os defaults de build (brands.ts) e o CSS atual.
 *
 * Contrato (idêntico ao dashboard): GET {REACT_APP_BRAND_CONFIG_URL}?brand=<slug>
 * → { theme?: Partial<BrandTheme>, launcherLogo?: string, launcherPosition?: LauncherPosition, borderRadius?: number }
 */
interface RemoteBrandConfig {
    theme?: Partial<BrandTheme>;
    launcherLogo?: string;
    launcherPosition?: LauncherPosition;
    borderRadius?: number;
    headerTitle?: string;
}

export async function getBrandConfig(brand: string): Promise<RemoteBrandConfig> {
    const baseUrl = (process.env.REACT_APP_BRAND_CONFIG_URL || "").trim();
    if (!baseUrl) {
        return {};
    }

    try {
        const separator = baseUrl.includes("?") ? "&" : "?";
        const response = await fetch(`${baseUrl}${separator}brand=${encodeURIComponent(brand)}`, {
            method: "GET",
            headers: { Accept: "application/json" }
        });

        if (!response.ok) {
            return {};
        }

        return (await response.json()) as RemoteBrandConfig;
    } catch (e) {
        log.warn("Couldn't fetch remote brand config; using build-time defaults", e);
        return {};
    }
}
